import { makeStyles } from "@material-ui/core";
import { fontFamily } from "../../../app/theme";

const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: "Axiforma, serif, sans-serif",
    background: "#fff"
  },
  paymentPageSection: {
    boxShadow: "0 0 15px 0 rgba(0, 0, 0, 0.07)",
    border: "solid 1px #e5e5e5",
    borderRadius: 4
  },
  paymentSection: {
    padding: theme.spacing(4),
    position: "relative"
  },
  summarySection: {},
  stripeLogo: {
    "display": "flex",
    "alignItems": "center",
    "position": "absolute",
    "top": "28px",
    "right": "34px",
    "width": "140px",
    "padding": "1px",
    "justifyContent": "center",
    "& img": { objectFit: "cover", width: "100%" },
    [theme.breakpoints.down("sm")]: {
      position: "relative",
      top: "0",
      right: "0",
      marginLeft: "0",
      marginBottom: "30px"
    }
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    marginTop: theme.spacing(2)
  },
  formItem: {
    "width": "100%",
    "display": "flex",
    "marginBottom": "26px",
    "& .MuiFormLabel-root": {
      fontSize: "15px",
      fontWeight: 600,
      color: "#6d6d6d",
      fontFamily: fontFamily.Axiforma,
      marginBottom: "4px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px"
      }
    },
    "& .MuiInputBase-input": {
      padding: "14px",
      fontSize: "14px",
      color: "#6d6d6d"
    },
    "& fieldset": {
      boxShadow: "0 1px 3px 0 rgba(220, 220, 220, 0.5)",
      border: "solid 1px #e0e0e0 !important",
      borderRadius: "9px"
    },
    "& .MuiInputBase-formControl:hover fieldset": {
      border: "solid 1px #e0e0e0"
    },
    "&.form-error": {
      "& fieldset": {
        boxShadow: "0 1px 3px 0 #fca5a5",
        border: "solid 1px #f87171 !important",
        borderRadius: "9px"
      },
      "& .MuiInputBase-formControl:hover fieldset": {
        border: "solid 1px #f87171"
      }
    }
  },
  formItemCard: {
    "boxShadow": "0 1px 3px 0 rgba(220, 220, 220, 0.5)",
    "border": "solid 1px #e0e0e0",
    "borderRadius": "9px",
    "& .card-number": {
      height: "47px",
      padding: "14px",
      borderBottom: "solid 1px #e0e0e0"
    },
    "& .card-expiry": {
      width: "50%",
      height: "47px",
      padding: "14px",
      borderRight: "solid 1px #e0e0e0"
    },
    "& .card-cvc": {
      width: "50%",
      height: "47px",
      padding: "14px"
    },
    "&.form-error": {
      "border": "solid 1px #f87171",
      "boxShadow": "0 1px 3px 0 #fca5a5",
      "& .card-number": {
        borderBottom: "solid 1px #f87171"
      },
      "& .card-expiry": {
        borderRight: "solid 1px #f87171"
      }
    }
  },
  formContainer: {
    maxWidth: "482px",
    width: "100%",
    fontFamily: fontFamily.Axiforma,
    [theme.breakpoints.down("sm")]: {
      padding: "0 24px"
    }
  },
  cardSection: {
    boxShadow: "0 1px 3px 0 rgba(220, 220, 220, 0.5)",
    border: "solid 1px #e0e0e0",
    borderRadius: "9px",
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));

export default useStyles;
